import React, {useEffect} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {setPricingSearchText} from "../pricingActions";
import {featuresSetupSetSearchTerm} from "../../FeaturesSetup/featuresActions";


const PricingTopPanelSearch = (props) => {

  const {intl, pricingSearchText, setPricingSearchText, featuresSetupSetSearchTerm} = props;

  useEffect(() => {
    return () => {
      setPricingSearchText("");
      featuresSetupSetSearchTerm("");
    }
  }, [])

  const onChange = (event) => {
    setPricingSearchText(event.target.value);
    featuresSetupSetSearchTerm(event.target.value);
  }

  return (
    <input placeholder={intl.formatMessage({id: "assignPopup.searchPlaceholder"})}
           type="search"
           onChange={onChange}
           value={pricingSearchText}
           className="pr-top-panel__search radius-5 text-center ui-input ui-input--gray4 ui-input--gray4--small ui-input--gray4--small--pr width-100"/>
  )
};

const mapStateToProps = (store) => {
  const {pricingSearchText} = store.pricingState;
  return {
    pricingSearchText,
  };
};

const mapDispatchToProps = {
  setPricingSearchText,
  featuresSetupSetSearchTerm,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PricingTopPanelSearch)
)
